/**
 * Configuración global de GSAP.
 *
 * Vive en un asset propio (y no en un <script> en línea) para poder cargarse
 * con `defer` justo detrás de animations.min.js: los scripts diferidos se
 * ejecutan en el orden del documento, así que esto corre siempre después de
 * cargar GSAP y antes de product.js / slideshow.js / app.js, igual que cuando
 * los scripts eran bloqueantes.
 */
if (typeof gsap !== 'undefined') {
  gsap.defaults({
    ease: Power4.easeOut
  });

  gsap.config({
    nullTargetWarn: false
  });

  var gsapPlugins = [];

  if (typeof ScrollTrigger !== 'undefined') {
    gsapPlugins.push(ScrollTrigger);
  }

  if (typeof DrawSVGPlugin !== 'undefined') {
    gsapPlugins.push(DrawSVGPlugin);
  }

  if (gsapPlugins.length) {
    gsap.registerPlugin.apply(gsap, gsapPlugins);
  }
}
